// extracted by mini-css-extract-plugin
module.exports = {"vc":"VCCard_vc__36Gop","job":"VCCard_job__2SVL1","text":"VCCard_text__2Yjbt","sending":"VCCard_sending__25KHG"};